import React from "react";
import auth from "../../../../firebase.init";
import {
  useCreateUserWithEmailAndPassword,
  useUpdateProfile,
} from "react-firebase-hooks/auth";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css";
import LoginSocial from "../LoginSocial/LoginSocial";
import Loading from "../Loading/Loading";
const Register = () => {
  const [createUserWithEmailAndPassword, user, loading, error] =
    useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });
  const [updateProfile, updating, errorUpdate] = useUpdateProfile(auth);
  const navigate = useNavigate();

  const navigateLogin = () => {
    navigate("/login");
  };
  if (loading || updating) {
    return <Loading></Loading>;
  }
  if (user) {
    console.log("user", user);
  }
  const handleRegister = async (event) => {
    event.preventDefault();
    const name = event.target.name.value;
    const email = event.target.email.value;
    const password = event.target.password.value;
    const agree = event.target.terms.checked;
    if (agree) {
      createUserWithEmailAndPassword(email, password);
      await updateProfile({ displayName: name });
      console.log("updated profile");
      navigate("/home");
    }
  };

  return (
    <div className="register-form">
      <h2 className="register-title">Register Your Email!</h2>
      <form onSubmit={handleRegister}>
        <input type="text" name="name" id="" placeholder="Your Name" />

        <input
          type="email"
          name="email"
          id=""
          placeholder="Email Address"
          required
        />

        <input
          type="password"
          name="password"
          id=""
          placeholder="Password"
          required
        />
        <input type="checkbox" name="terms" id="terms" />
        <label htmlFor="terms">Accept all rules and regulaton</label>

        <input type="submit" value="Register" className="btn-register" />
      </form>
      <p>
        Already have an email account?
        <Link
          to="/login"
          className="pe-auto text-primary"
          onClick={navigateLogin}
        >
          Please Login!
        </Link>
      </p>
      <LoginSocial></LoginSocial>
    </div>
  );
};

export default Register;
